import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { NamedTemplateComponent } from './named-template.component';

@NgModule({
    imports: [CommonModule, TwcModule, TranslateModule],
    declarations: [NamedTemplateComponent],
    exports: [NamedTemplateComponent],
})
export class NamedTemplateModule {}
